import { sleep } from './sleep';

interface RetryOptions {
	count?: number;
	ms?: number;
}
export const retry = async <T>(loader: () => Promise<T>, options: RetryOptions = {}): Promise<T> => {
	const innerOptions: Required<RetryOptions> = {
		count: 3,
		ms: 250,
		...options,
	};
	try {
		const object = await loader();
		return object;
	} catch (e) {
		if (innerOptions.count <= 1) {
			throw e;
		}

		await sleep(innerOptions.ms);

		return retry(loader, {
			...innerOptions,
			count: innerOptions.count - 1
		});
	}
};
